import React from 'react';
import { ShoppingCart } from 'lucide-react';
import '../styles/Header.css';

const Header = () => {
  return (
    <div className="header-container">
      <div className="header-badge">
        <ShoppingCart size={40} color="white" />
        <h1 className="header-title">Grocery Manager</h1>
      </div>
      <p className="header-subtitle">
        Organize your shopping list with ease
      </p>
    </div>
  );
};

export default Header;